
  export const style={
    inpuStyle:{
      colorInput:"#245270"
    },
    url:{
      urlClient:"https://clubcasa.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_client_clubcasa_new.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: false,
       recaptchaVersion : "V2"
    },
    CurrencyName:{
      name:"Club/Clubs"
    },
    teamName:{
      name:"ClubCasa"
    },
    hasToken: true,
    hostHeader: "clube&casa"
  }
